/*
 * WHICH root the entry mounts (04-frontend/architecture.md §5, tree shape).
 *
 * A path under `/verify/` is a public passport verification — almost always a
 * QR scan on a phone — and mounts PG-25 alone, so that visit downloads the
 * verifier and nothing of the application: no router, providers, session,
 * theme or catalogs (pages/passport-verify.md criterion 10, "QR scans must
 * not pay for the app bundle"). Every other path mounts the application.
 *
 * No import: this module is part of the entry chunk every visit downloads.
 */
export const PUBLIC_VERIFIER_PREFIX = '/verify/';

export type BootTarget = 'verifier' | 'application';

export const bootTargetOf = (pathname: string): BootTarget => {
  return pathname.startsWith(PUBLIC_VERIFIER_PREFIX) ? 'verifier' : 'application';
};
